import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBxSend = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 19 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m18.426 8.095-17-8A.999.999 0 0 0 .03 1.242L1.969 9 .03 16.758a.998.998 0 0 0 1.396 1.147l17-8a1 1 0 0 0 0-1.81ZM2.481 15.197l.839-3.357L9 9 3.32 6.16l-.839-3.357L15.651 9l-13.17 6.197Z"
	})
});
export default SvgBxSend;
